<template>
  <el-dialog
    title="提示"
    :visible.sync="csDialogVisible"
    :before-close="cancelClick"
    :width="courseResType === 20 ? '40%' : '70%'">
    <div v-if="courseResType === 20">
      <div>
        修改后该课程排期场地无需强制设置为腾讯会议场地。
      </div>
      <br/>
      <div>
        该课程已存在关联的排期，如需更改排期场地，请导出留存。
      </div>
      <div style="text-align: right; margin-top: 10px;">
        <span slot="footer" class="dialog-footer">
          <!-- <el-button v-if="courseResType === 20" @click="cancelClick">取 消</el-button> -->
          <!-- <el-button v-if="courseResType === 20" type="primary" @click="exportClick">导出</el-button> -->
          <el-button v-if="courseResType === 20" type="primary" @click="submitClick">确定并导出</el-button>
        </span>
      </div>
      
    </div>
    <div v-if="courseResType === 10">
      <div>
        若课程信息更改为：【课程分类 - 经销商】、【课程类型 - 远程培训】，则排期场地必须选择腾讯会议。
      </div>
      <br/>
      <div>
       请将如下排期的场地更改为腾讯会议后，再对课程分类、课程类型进行修改。
      </div>
      <div style="text-align: right;">
        <el-button size="small" type="primary" @click="exportClick">导出</el-button>
      </div>
      <div style="margin-top: 10px;">
        <el-table
          :data="courseVerificationForm"
          style="width: 100%">
          <el-table-column
            prop="offeringNo"
            label="排期编号"
            width="180">
          </el-table-column>
          <el-table-column
            prop="offeringStatus"
            label="排期发布状态"
            width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.offeringStatus === '20' ? '已发布' : '未发布' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="startdate"
            label="排期开始时间">
          </el-table-column>
          <el-table-column
            prop="enddate"
            label="排期结束时间">
          </el-table-column>
          <el-table-column
            prop="offeringRemark"
            label="说明">
          </el-table-column>
        </el-table>
        <el-pagination
          ref="pagination"
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="currentPage"
          @size-change="sizeChange"
          @current-change="currentChange">
        </el-pagination>
      </div>
      <div style="text-align: right; margin-top: 10px;">
        <span slot="footer" class="dialog-footer">
          <el-button v-if="courseResType === 10" @click="cancelClick">关 闭</el-button>
        </span>
      </div>
    </div>
  </el-dialog>  
</template>

<script>
import http from "@/utils/http";
export default {
  components: {},
  props: {
    csDialogVisible: Boolean,
    courseVerificationForm: Array,
    total: Number,
    courseResType: Number,
    courseObj: Object
  },
  data() {
    return {
      tableData: [
        {
          offeringNo: 'test',
          offeringStatus: 'test',
          startdate: 'test',
          enddate: 'test',
          remark: 'test'
        }
      ],
      currentPage: 1
    }
  },
  methods: {
    currentPageFun() {
      console.log('------')
      this.currentPage = 1
    },
    cancelClick() {
      console.log('------')
      this.currentPage = 1
      // this.$refs.pagination.internalCurrentPage = this.currentPage
      this.$emit('courseVerificationOk', 'cancel')
    },
    submitClick() {
      this.exportClick()
      this.$emit('courseVerificationOk', 'submit')
    },
    currentChange(val) {
      console.log(val)
      let page = val
      this.$emit('coursePageOk', page)
    },
    sizeChange(val) {
      console.log(val)
    },
    exportClick() {
      let param = {}
      let url = this.$request.getlearningS("/learning/base/offeringinfo/checkUpdateCourseTypeExport", {});
      param.responseType = "blob";
      param["language"] = "Cn";
      let downloadFileName =
        "download.xls" && this.$t("offering.offeringExport") + ".xls";
      http.get(`${url.url}?courseId=${this.courseObj.courseId}&catalogId=${this.courseObj.catalogId}&courseType=${this.courseObj.courseType}`, param).then((data) => {
        console.log("http.get");
        console.log(data);
        let reader = new FileReader();
        let blob = new Blob([data], { type: "application/vnd.ms-excel;charset=utf8" });
        //this.$message(this.myBrowser()+'')
        if (this.myBrowser() === "IE" || this.myBrowser() === "Edge") {
          window.navigator.msSaveBlob(blob, downloadFileName);
        } else {
          let down = document.createElement("a");
          let href = window.URL.createObjectURL(blob);
          down.href = href;
          down.download = downloadFileName;
          document.body.appendChild(down);
          down.click();
          document.body.removeChild(down);
          window.URL.revokeObjectURL(href);
        }
        //loading.close();
        //loadingInstance.close();
        // this.$nextTick(() => {
        //   // 以服务的方式调用的 Loading 需要异步关闭
        //   loadingInstance.close();
        // });
        // this.fullscreenLoading = false;
      });
      // this.$request.get(
      //   `/learning/base/offeringinfo/checkUpdateCourseTypeExport?courseId=${this.courseObj.courseId}&catalogId=${this.courseObj.catalogId}&courseType=${this.courseObj.courseType}`,
      //   {}
      // ).then((res, total, code, data) => {
      //   console.log(res)
      // }).catch((err) => {
      //   console.log(err)
      // })
    },
    myBrowser() {
      var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
      if (userAgent.indexOf("OPR") > -1) {
        return "Opera";
      } // 判断是否Opera浏览器 OPR/43.0.2442.991
      if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
      } // 判断是否Firefox浏览器 Firefox/51.0
      if (userAgent.indexOf("Trident") > -1) {
        return "IE";
      } // 判断是否IE浏览器  Trident/7.0; rv:11.0
      if (userAgent.indexOf("Edge") > -1) {
        return "Edge";
      } // 判断是否Edge浏览器  Edge/14.14393
      if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
      } // Chrome/56.0.2924.87
      if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
      } // 判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2
    },
  }
}
</script>

<style scoped lang="scss">
.mainClass {
  width: 100%;
  min-height: 100px;
}
</style>
